export const pages = [
  ['/', 'Overview'],
  ['/patient-advice', 'Patient recommendations'],
  ['/experience', 'Experience'],
  ['/publications', 'Publications'],
  ['/presentations', 'Presentations'],
  ['/affiliations', 'Affiliations & languages'],
];

export const academicPages = pages.slice(2);
